// Form-data fields that save an inbox's country signatures, one per country. Form data
// cannot carry an empty object, so a country that was stored but is gone now is sent as
// '', which the backend drops. A country moved to another one is the old one gone plus
// the new one.
export const countrySignatureFields = (stored, current) => {
  const countries = new Set([
    ...Object.keys(stored || {}),
    ...Object.keys(current || {}),
  ]);
  return Object.fromEntries(
    [...countries].map(country => [
      `country_signatures[${country}]`,
      current?.[country] || '',
    ])
  );
};
